import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { PatientConsentPDDEGDUBaseAnimatingComponent } from "./PatientConsentPDDEGDUBaseAnimatingComponent";
import { ConfirmButton } from "./PatientConsentManagerShared.styles";
import { FastenCustomUI } from "./FastenCustomUI";
import { HorizontalDivider } from "./common.styles";
import { ErrorContainer as LoginErrorContainer } from "./DocumentRetrievalLoginLocation.styles";
import { FastenErrorText } from "./DocumentRetrievalReviewAndShare.styles";
export const DocumentRetrievalContinueWithoutSharing = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const [isLoading, setIsLoading] = React.useState(false);
    const handleConfirmContinue = async () => {
        if (isLoading)
            return;
        setIsLoading(true);
        await props.onConfirmContinue();
    };
    let title;
    if (props.isIAS) {
        title = t("Continue without accessing records?");
    }
    else if (props.isAIFlow) {
        title = t("Continue without connecting records?");
    }
    else {
        title = t("Continue without sharing records?");
    }
    let supportingText;
    if (props.isIAS) {
        supportingText = t("By continuing without accessing records, you won’t get your HealthEx Unified Record.");
    }
    else if (props.isAIFlow) {
        supportingText = t("By continuing without connecting records, you won’t be connected with {{ aiToolName }}.", {
            aiToolName: props.aiToolName,
        });
    }
    else {
        supportingText = t("By continuing without sharing records, you won't share any records with {{ orgName }} for this request.", {
            orgName: props.organizationName,
        });
    }
    const hasSeenDocumentSelectionScreen = props.model.uiState.hasSeenDocumentSelectionScreen;
    const animate = !hasSeenDocumentSelectionScreen;
    return (_jsx(PatientConsentPDDEGDUBaseAnimatingComponent, { title: title, supportingText: supportingText, animate: animate, buttons: _jsxs(_Fragment, { children: [props.model.fastenAuthError && (_jsxs(_Fragment, { children: [_jsx(HorizontalDivider, {}), _jsx(LoginErrorContainer, { style: { marginTop: 10, marginBottom: 10 }, children: _jsx(FastenErrorText, { children: t("An error occurred. Please try authorizing again") }) })] })), _jsx(ConfirmButton, { onClick: handleConfirmContinue, loading: isLoading, disabled: isLoading, children: t("Yes, continue") }), _jsx(FastenCustomUI, { isStatic: props.isStatic, onAddAnotherClicked: props.onAddAnotherClicked, heapId: "continue-without-sharing-add-provider-button", buttonText: t("Add a provider"), container: props.container, loading: props.model.isAuthLoading, model: props.model, justifyContent: "center", useSecondaryStyle: false })] }) }));
});
addDisplayName(DocumentRetrievalContinueWithoutSharing, "DocumentRetrievalContinueWithoutSharing");
